import { useEffect, useRef, useState } from 'react'

import { addPaymentBreadcrumb } from '@/lib/sentry'
import { useGetProductPaymentProcess, usePostCallbackNaverpaySuccess } from '@/payment'

import { useTokenReady } from '../../hooks/useTokenReady'
import { LoadingView, SuccessView, UnknownView } from '../StateViews'

/**
 * `?key=` (토스/네이버 success) 흐름:
 * 토큰 준비 → GET /product-payments/process/{key} → 네이버 콜백 → 완료.
 */
export function KeyFlow({ processKey }: { processKey: string }) {
  const tokenStatus = useTokenReady()
  const processQuery = useGetProductPaymentProcess(tokenStatus === true ? processKey : null)
  const naverCallback = usePostCallbackNaverpaySuccess()
  const [callbackError, setCallbackError] = useState(false)
  const [callbackDone, setCallbackDone] = useState(false)
  const callbackFiredRef = useRef(false)

  useEffect(() => {
    if (!processQuery.data) return
    if (callbackFiredRef.current) return
    callbackFiredRef.current = true

    const { paymentMethodType, paymentId, paymentKey } = processQuery.data
    if (paymentMethodType === 'NAVERPAY') {
      naverCallback.mutate(
        {
          paymentId,
          body: { naverpayPaymentId: paymentKey, paymentMethodType: 'NAVERPAY' },
        },
        {
          onSuccess: () => {
            addPaymentBreadcrumb('네이버 콜백 성공', { paymentId })
            setCallbackDone(true)
          },
          onError: () => {
            addPaymentBreadcrumb('네이버 콜백 실패', { paymentId })
            setCallbackError(true)
          },
        }
      )
      return
    }

    // NAVERPAY 외 (TOSS_QUICK_ACCOUNT 등) — 이번 phase 미지원.
    setCallbackError(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processQuery.data])

  if (tokenStatus === false) return <UnknownView />
  if (processQuery.isError || callbackError) return <UnknownView />
  if (tokenStatus === null || !processQuery.data || !callbackDone) return <LoadingView />
  return <SuccessView />
}
